import { Link, useRouterState } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

export function SettingsLayout({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const tabs = [
    { to: '/settings/profile', label: t('settings.profile') },
    { to: '/settings/security', label: t('settings.security') },
  ] as const;
  return (
    <div className="mx-auto max-w-2xl">
      <h1 className="mb-4 text-lg font-semibold">{t('settings.title')}</h1>
      <nav aria-label={t('settings.title')} className="mb-4 inline-flex rounded-lg bg-muted p-1">
        {tabs.map((tab) => (
          <Link
            key={tab.to}
            to={tab.to}
            aria-current={pathname === tab.to ? 'page' : undefined}
            className={cn(
              'rounded-md px-3 py-1 text-sm font-medium',
              pathname === tab.to ? 'bg-background shadow' : 'text-muted-foreground',
            )}
          >
            {tab.label}
          </Link>
        ))}
      </nav>
      {children}
    </div>
  );
}
